import { memo, useEffect, useState } from 'react'
import InfoCount from './InfoCount'
import { useDispatch } from 'react-redux'
import { setPageName } from '../../../../redux'
import CarsBox from '../cars/CarsBox'
import { getData } from '../../../../assets/scripts/GeneralFunctions'
import { COUNT_INFO } from '../../../../functions/stateList'

function Dashboard() {
  const [info_count, setInfoCount] = useState({
    all_cars: NaN,
    today_cars: NaN,
    users: NaN,
  })
  const [lazy_load_data, setLazyLoadData] = useState({
    limit: 10,
    offset: 0,
  })
  const [cars, setCars] = useState([NaN, NaN])
  const [car_models, setCarModels] = useState([])
  const [customer_types, setCustomerTypes] = useState([])
  const [customers, setCustomers] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchData() {
      dispatch(setPageName('dashboard'))
      let api_result = await getData(
        'admin/dashboard',
        'get',
        {
          ...lazy_load_data,
        },
        true
      )
      if (api_result) {
        if (api_result?.status === 200) {
          let result_data = api_result?.data
          setInfoCount({
            all_cars: result_data?.['total_registered_cars'],
            today_cars: result_data?.['registered_cars_today'],
            users: result_data?.['total_registered_customers'],
          })
          setCars(result_data?.data)
          setCarModels(result_data?.car_models)
          setCustomerTypes(result_data?.customer_types)
          setCustomers(result_data?.customers)
          setLazyLoadData({
            limit: 10,
            offset: 0,
          })
        }
      }
    }
    fetchData()
  }, [])

  return (
    <>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 mb-8">
        {COUNT_INFO &&
          COUNT_INFO.map((info) => (
            <InfoCount
              key={info.id}
              count={info_count[info.title]}
              icon={info.icon}
              text={info.text}
            />
          ))}
      </div>
      <CarsBox
        setLazyLoadData={setLazyLoadData}
        lazy_load_data={lazy_load_data}
        isDashboard={true}
        cars={cars}
        setCars={setCars}
        car_models={car_models}
        customer_types={customer_types}
        customers={customers}
      />
    </>
  )
}

export default memo(Dashboard)
